import { Controller } from '@hotwired/stimulus'
import {
  uploadFilesToS3,
  areAllFilesUploaded,
  isFileUploaded,
} from '../../modules/s3_uploader'

export default class extends Controller {
  static targets = [
    'documentForm',
    'uploadOrder',
  ]

  connect() {
    this.bindHandleEvent()
  }

  bindHandleEvent() {
    this.documentFormTarget.addEventListener('submit', this.submitForm.bind(this))
  }

  collectDocumentData(form) {
    var documentData = []

    form.querySelectorAll('.document-item').forEach((item) => {
      const documentItem = {
        document_type: item.getAttribute('data-document-type')
      }

      const fileData = fileElement.getAttribute('data-file')
      documentItem.file = JSON.parse(fileData).key

      documentData.push(documentItem)
    })

    const inputElement = document.createElement('input')
    inputElement.type = 'hidden'
    inputElement.name = 'document_data'
    inputElement.value = JSON.stringify(documentData)

    form.appendChild(inputElement)
  }

  async submitForm(event) {
    const form = event.currentTarget

    if (!areAllFilesUploaded(form)) {
      event.preventDefault()

      form.submit.disabled = true
      await this._uploadAllFiles(form, 'cart_documents/')

      // Disable file inputs that have files uploaded
      form.querySelectorAll('.s3-upload-item').forEach((fileElement) => {
        if (fileElement.files.length > 0) {
          fileElement.disabled = true;
        }
      });

      form.submit.disabled = false
      return form.submit.click()
    }
  }


  _uploadAllFiles(formElement, s3FilePrefix) {
    const fileElements = formElement.querySelectorAll('.s3-upload-item')

    // Create an array of promises for each file upload
    const uploadPromises = Array.from(fileElements).map((fileElement) => {
      if (fileElement.files.length === 0 || isFileUploaded(fileElement)) {
        return Promise.resolve() // Return resolved promise if no files or already uploaded
      }

      return new Promise((resolve, reject) => {
        uploadFilesToS3(
          s3FilePrefix,
          fileElement,
          (res) => {
            const keyJSON = JSON.stringify(
              res.map((r) => ({ key: r.key, upload_token: r.upload_token })),
            )
            this._addHiddenInput(formElement, fileElement.name, keyJSON)
            resolve() // Resolve the promise after successfully uploading
          },
          (err) => reject(err), // Reject the promise if there's an error
        )
      })
    })

    // Wait for all file upload promises to complete
    return Promise.all(uploadPromises)
      .then(() => {
        console.log('All files have been uploaded.')
      })
      .catch((error) => {
        console.error('Error uploading files:', error)
      })
  }

  _addHiddenInput(formElement, name, value) {
    const hiddenInput = document.createElement('input')
    hiddenInput.type = 'hidden'
    hiddenInput.name = name
    hiddenInput.value = value
    formElement.appendChild(hiddenInput)
  }
}
